export default "__VITE_ASSET__da34e495__"